<template>
    <v-container class="px-12">
        <div class="title">Contact SCB</div>
        <div class="my-3">
            Help us keep the portal as up-to-date as possible: alert us to standards that should be considered for inclusion, updates we may have overlooked, or inconsistencies you noticed. Or simply tell us what you think.
        </div>
        <ContactForm></ContactForm>
        <div class="my-12 px-12">
            <v-divider></v-divider>
        </div>
        <div class="text-center my-12">
            <div class="address-name">Standards Coordinating Body for Regenerative Medicine</div>
            <div class="mt-3">
                100 Bureau Drive<br />
                MS 8543, Bldg 224/A105<br />
                Gaithersburg, MD 20899<br />
            </div>
            <div class="mt-3">
                +1.301.975.6822
            </div>
            <div class="mt-3">
                <a href="mailto:admin@regenmedscb.org">admin@regenmedscb.org</a>
            </div>
        </div>
    </v-container>
</template>

<script>
    import ContactForm from '@/components/ContactForm';

    export default {
        name: 'Contact',
        components: { ContactForm }
    };
</script>

<style lang="scss" scoped>
    .address-name {
        font-family: $heading-font-family;
        text-transform: uppercase;
    }
</style>
